import { render, staticRenderFns } from "./TransactionDescription.vue?vue&type=template&id=375a57e5&"
import script from "./TransactionDescription.vue?vue&type=script&lang=js&"
export * from "./TransactionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports